import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Labels } from 'Services/institution'
// Types //
export interface LocationTypes {
  locId: string | null
  instId: string | null
  tourId: string | null
  stops: Array<any> | null
}

const initialState = {
  locId: null,
  instId: null,
  tourId: null,
  instName: null,
  stops: null,
  introMedia: null,
  labels: null,
} as LocationTypes

const locationSlice = createSlice({
  name: 'Location',
  initialState,
  reducers: {
    setLocation: (
      state,
      action: PayloadAction<{
        locId?: string
        instId?: string
        tourId?: string
        stops?: Array<any>
        instName?: string
        introMedia?: number
        labels?: Labels
      }>
    ) => {
      const newState = {
        locId: action.payload.locId,
        instId: action.payload.instId,
        tourId: action.payload.tourId,
        stops: action.payload.stops,
        instName: action.payload.instName,
        introMedia: action.payload.introMedia,
        labels: action.payload.labels,
      }
      return { ...state, ...newState }
    },
  },
})

const { actions, reducer } = locationSlice
export const { setLocation } = actions
export default reducer
